import React from 'react';
import BaseList from 'components/lists/BaseList';
import { useAccessLog } from 'hooks/logs';

function ListEquipmentPacking(props) {
  useAccessLog('Acesso ao cadastro de embalagens');
  const { match } = props;
  return (
    <BaseList
      columns={[
        { value: row => row.name, label: 'Nome', sort: 'name' },
      ]}
      genericSearchFields={[
        { label: 'Nome', name: 'name' },
      ]}
      basePath="equipment-packing"
      title="Lista de Embalagens"
      addButtonText="Cadastrar Embalagem"
      addUrl={`${match.path}/novo`}
    />
  );
}

export default ListEquipmentPacking;
